import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import './styles/main.css'

import App from './App'
import createStore from './store/store'
import {ThroughProvider} from 'react-through'

const { store } = createStore()

render(
	<Provider store={store}>
		<ThroughProvider>
			<App />
		</ThroughProvider>
	</Provider>,
	document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js